export const USER_EVENTS = {
  EMAIL_CAPTURE: 'emailCapture',
  CONVO_UPDATED: 'conversation',
  CONVO_CAMPAIGNS: 'campaign-conversations',
  CONVO_ENROLLMENT: 'campaign-enrollment',
  BOOTSTRAP_COMPLETE: 'bootstrap:complete',
  BOOTSTRAP_TIMEOUT: 'bootstrap:timeout'
}
